import type { ICommand } from '@model-framework/command';
import type { PositionSet } from './PositionSet';
import type { IPositionSetRepository } from './IPositionSetRepository';
import type { DBPath } from 'balus-common';
import { PositionSetRepository } from './infrastructure/PositionSetRepository';

export class PositionSetDeleteCommand implements ICommand {
  private readonly repository: IPositionSetRepository;

  constructor(
    private readonly currentValue: PositionSet,
    path: DBPath
  ) {
    this.repository = new PositionSetRepository(path);
  }

  do(): void {
    this.repository.deleteMany(this.currentValue.allIds()).then();
  }

  undo(): void {
    this.repository.saveMany(this.currentValue).then();
  }

  redo(): void {
    this.do();
  }

  async canUndo(): Promise<boolean> {
    const currentPositions = await this.repository.getMany(this.currentValue.allIds());
    return currentPositions.isEmpty();
  }

  async canRedo(): Promise<boolean> {
    const currentPositions = await this.repository.getMany(this.currentValue.allIds());
    return currentPositions.isEqual(this.currentValue);
  }
}
